import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const TrackerEmbedTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TrackerEmbedTippy/TrackerEmbedTippy.vue'));

app.component('TrackerEmbedTippy', TrackerEmbedTippy);

document.addEventListener('DOMContentLoaded', () => {
    const ICON_RESET_DELAY = 1000;

    document.querySelector('.article-container').addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (target && target.closest('.share-copy-btn')) {
            const button = target.closest('.share-copy-btn') as HTMLElement;
            const url = button.getAttribute('data-url');

            navigator.clipboard.writeText(url).then(() => {
                const icon = button.querySelector('i');
                const originalClass = icon.className;
                icon.className = 'fa-solid fa-check text-success';

                setTimeout(() => {
                    icon.className = originalClass;
                }, ICON_RESET_DELAY);
            });
        }
    });
});

mountApp();
